import { NavLink, useNavigate } from "react-router-dom";
import { Home, Search, Plus, User, Wallet } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function BottomNav() {
    const { user } = useAuth();
    const navigate = useNavigate();

    const goCreate = () => {
        if (!user) return navigate("/login");
        if (user.role !== "seller") return navigate("/onboarding");
        navigate("/upload");
    };

    const linkCls = ({ isActive }) =>
        `flex flex-col items-center gap-1 py-2 px-3 transition-colors ${
            isActive ? "text-[#FF5722]" : "text-white/70 hover:text-white"
        }`;

    return (
        <nav
            data-testid="bottom-nav"
            className="fixed bottom-0 left-0 right-0 z-50 pb-safe bg-black/90 backdrop-blur-md border-t border-white/10"
        >
            <div className="max-w-lg mx-auto flex items-center justify-around">
                <NavLink to="/feed" className={linkCls} data-testid="nav-feed">
                    <Home className="w-6 h-6" strokeWidth={2} />
                    <span className="text-[10px] font-body font-medium">Feed</span>
                </NavLink>
                <NavLink to="/search" className={linkCls} data-testid="nav-search">
                    <Search className="w-6 h-6" strokeWidth={2} />
                    <span className="text-[10px] font-body font-medium">Recherche</span>
                </NavLink>
                <button
                    data-testid="nav-create"
                    onClick={goCreate}
                    className="flex flex-col items-center -mt-6"
                >
                    <span className="w-14 h-14 rounded-full bg-[#FF5722] flex items-center justify-center shadow-[0_8px_24px_rgba(255,87,34,0.5)] active:scale-95 transition-transform">
                        <Plus className="w-7 h-7 text-white" strokeWidth={3} />
                    </span>
                </button>
                <NavLink to="/wallet" className={linkCls} data-testid="nav-wallet">
                    <Wallet className="w-6 h-6" strokeWidth={2} />
                    <span className="text-[10px] font-body font-medium">Crédits</span>
                </NavLink>
                <NavLink to="/dashboard" className={linkCls} data-testid="nav-profile">
                    <User className="w-6 h-6" strokeWidth={2} />
                    <span className="text-[10px] font-body font-medium">Compte</span>
                </NavLink>
            </div>
        </nav>
    );
}
